import React from 'react';
import PropTypes from 'prop-types';

import { YES_FLAG, NO_FLAG } from '../constants';

export const getMappedGridTextValue = ({ value, fieldName }) => {
  switch (fieldName) {
    case 'amountFrom': {
      if (value === YES_FLAG) {
        return 'Trial Balance';
      }
      if (value === NO_FLAG) {
        return 'Manual';
      }
      return value;
    }
    case 'frequency': {
      if (value === YES_FLAG) {
        return 'Recurring';
      }
      if (value === NO_FLAG) {
        return 'One Time';
      }
      return value;
    }
    case 'annualCum': {
      if (value === YES_FLAG) {
        return 'Yes';
      }
      if (value === NO_FLAG) {
        return 'No';
      }
      return value;
    }
    case 'multiplier':
      return value ? `${value }%` : '-';
    case 'disallowedPer':
      return `${Math.round(value * 100) }%`;
    case 'exceptionType':
    case 'typeName': {
      const exceptionTypes = {
        T: 'Temp',
        P: 'Perm',
        TAXCREDIT: 'Tax Credit',
        G: 'GAAP to STAT Non-Reversing',
      };
      return exceptionTypes[value] || 'value not defined';
    }
    default:
      return 'field not defined';
  }
};

function TextCellRenderer(props) {
  const { value, colDef: { field: fieldName } } = props;
  return (
    <span>
      {getMappedGridTextValue({ value, fieldName })}
    </span>
  );
}

TextCellRenderer.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  colDef: PropTypes.shape({
    field: PropTypes.string,
  }),
};

export default TextCellRenderer;
